import React, { useState, useEffect } from 'react';
import QuestionList from './QuestionList';
import RightNavBar from './RightNavBar';
import './AboutChat.css';

function AboutChat() {
    const questionToAnswer = {
        "What do you do?": "I am studying towards my Master's in Computer Science at Columbia University, following the track of Computer Graphics and Vision.",
        "What is your expected graduation date?": "May 2022",
        "Why Computer Graphics and Vision?": "I find that I work best when I can visualize the desired effect of my work, and Visual Computing makes that easy.",
        "Where are you from?": "Bucharest, Romania",
        "Where did you graduate from?": "I graduated from Ecole Polytechnique in France, with a double degree in Mathematics and Computer Science.",
        "What is your favorite ice cream?": "Ben & Jerry's Coconut Seven Layer Bar",
        "What kind of jobs are you looking for?": "Junior positions or recently graduate positions in Software Engineering, Front-end development, Game Development, or Rendering Engineering",
        "Where do you live?": "New York City",
        "Three words that describe you?": "Curious, motivated, funny"
    }

    const questions = Object.keys(questionToAnswer);

    const [ greetingMessage, setGreetingMessage ] = useState("Hi! Ask any of the suggested questions on the right side of the screen by clicking on them.");
    const responsiveGreeting = () => {
        if (window.innerWidth <= 960) {
            setGreetingMessage("Hi! Ask any of the suggested questions below by clicking on them.");
        }
    };

    useEffect(() => { responsiveGreeting() }, []);
    window.addEventListener('resize', responsiveGreeting);

    const [ questionsLeft, setQuestionsLeft ] = useState(questions.length);
    const [ conversationMessages, setConversationMessages ] = useState([]);
    const askQuestion = (question) => {
        setConversationMessages([...conversationMessages, question, questionToAnswer[question]]);
        setQuestionsLeft(questionsLeft - 1);
    }

    let messageIntoView = document.getElementsByClassName("last-message")[0];
    function scrollMessageIntoView() {
        let eligibleMessages = document.getElementsByClassName("last-message");
        messageIntoView = eligibleMessages[eligibleMessages.length - 1];
        messageIntoView.scrollIntoView({behavior: "smooth"})
    };

    useEffect(scrollMessageIntoView, [conversationMessages]);

    return (
        <>
            <div className="page-content">
                <div className="conversation-header">
                    <img src="/images/close-up.jpg" alt="Maria" className="conversation-photo" />
                    <ul>
                        <li className="bold-element profile-tag" key={0}>
                            <i className="fa fa-circle" />
                            Maria
                        </li>
                        <li className="italic-element" key={1}>
                            I love coding, animals, and french fries
                        </li>
                    </ul>
                </div>
                <div className="conversation-container">
                    <div className="conversation last-message">
                        <div className="reply reply-me">{greetingMessage}</div>
                    </div>
                    {conversationMessages.map((item, index) => {
                        return (index % 2 !== 0) ?
                            (<div className="conversation">
                                <div className="reply reply-me">{item}</div>
                            </div>) :
                            (<div className="conversation conversation-user last-message">
                                <div className="reply reply-user">{item}</div>
                            </div>)
                    })}
                </div>
            </div>
            <RightNavBar>
                <div className="question-caption italic-element">
                    {(questionsLeft > 0) ?
                    "Some things you might want to know about me..." :
                    "Guess you're all set!"}
                </div>
                <QuestionList questions={questions} onQuestionClick={askQuestion} />
            </RightNavBar>
        </>
    )

}

export default AboutChat;